import { memo } from "react";
import { StyleSheet } from "react-native-unistyles";
import Animated, { type AnimatedStyle } from "react-native-reanimated";
import type { ViewStyle } from "react-native";
import { VideoControlButton } from "./VideoControlButton";

type AnimatedMuteButtonProps = {
  isMuted: boolean;
  animatedStyle: AnimatedStyle<ViewStyle>;
  onPress: () => void;
};

export const AnimatedMuteButton = memo(({ isMuted, animatedStyle, onPress }: AnimatedMuteButtonProps) => {
  return (
    // pointerEvents is carried by `animatedStyle` (tied to the fade opacity) so the
    // button is never clickable while invisible — see ClipVideoPlayer controlsAnimatedStyle.
    <Animated.View style={[styles.container, animatedStyle]}>
      <VideoControlButton
        icon={isMuted ? "volumeOff" : "volumeOn"}
        size="small"
        onPress={onPress}
        accessibilityLabel={isMuted ? "Unmute audio" : "Mute audio"}
      />
    </Animated.View>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    position: "absolute",
    bottom: theme.spacing.lg,
    left: theme.spacing.lg,
    zIndex: 10000,
  },
}));
